import { useTheme, themes } from './ThemeProvider';
import { Sun, Moon } from 'lucide-react';
import { cn } from '@/src/lib/utils';
import { Button } from '@/src/shadComponents/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/src/shadComponents/ui/popover';
import { Palette } from 'lucide-react';

export default function ThemePicker() {
    const { theme, mode, setTheme, setMode } = useTheme();

    return (
        <Popover>
            <PopoverTrigger className="peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! h-8 [&>svg]:size-4 [&>svg]:shrink-0 [&>span]:truncate cursor-pointer">
                <Palette />
                <span>Theme</span>
            </PopoverTrigger>
            <PopoverContent side="top" align="start" className="w-64">
                <div className="space-y-4">
                    <div>
                        <h4 className="text-sm font-medium text-foreground mb-1">
                            Theme
                        </h4>
                        <p className="text-xs text-muted-foreground">
                            Pick a color scheme for the app.
                        </p>
                    </div>

                    <div className="grid grid-cols-5 gap-2">
                        {themes.map((t) => (
                            <button
                                key={t.name}
                                onClick={() => setTheme(t.name)}
                                className={cn(
                                    'flex flex-col items-center gap-1.5 rounded-md p-2 text-xs transition-colors cursor-pointer outline-none',
                                    theme.name === t.name
                                        ? 'bg-accent ring-2 ring-ring'
                                        : 'hover:bg-accent/50',
                                )}
                                title={t.label}
                            >
                                <div
                                    className="size-6 rounded-full border-2 border-background shadow-sm"
                                    style={{ backgroundColor: t.swatch }}
                                />
                                <span className="text-[10px] font-medium text-muted-foreground">
                                    {t.label}
                                </span>
                            </button>
                        ))}
                    </div>

                    <div className="border-t pt-3">
                        <h4 className="text-sm font-medium text-foreground mb-2">
                            Mode
                        </h4>
                        <div className="flex gap-2">
                            <Button
                                variant={mode === 'light' ? 'default' : 'outline'}
                                size="sm"
                                className="flex-1"
                                onClick={() => setMode('light')}
                            >
                                <Sun className="size-4" />
                                Light
                            </Button>
                            <Button
                                variant={mode === 'dark' ? 'default' : 'outline'}
                                size="sm"
                                className="flex-1"
                                onClick={() => setMode('dark')}
                            >
                                <Moon className="size-4" />
                                Dark
                            </Button>
                        </div>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    );
}
